import accountReducer from '@/slices/account';
import errorsReducer from '@/slices/errors';
import { combineReducers } from '@reduxjs/toolkit';

export const rootReducer = combineReducers({
  account: accountReducer,
  errors: errorsReducer,
});
